<script>
	import {mapGetters} from 'vuex'
	import Join from '@/components/Join'
	export default {
		name: 'Start',
		data() {
			return {
				componentName: 'Start',
			}
		},
		components: {Join},
		props: [],
		beforeRouteEnter(to, from, next) {
			next(vm => {
				// access to component instance via `vm`
				if (this.account && this.account.uid) {
					next()
				} else {
					next('/NewProfile')
				}
			})
		},
		computed: {
			...mapGetters(['account']),
		},
		methods: {},
		mounted() {
			// Called after the instance has just been mounted where el is replaced by the newly created vm.el. If the root instance is mounted to an in-document element, vm.el will also be in-document when mounted is called.
			this.$nextTick(() => {
				// console.log('<Start> is ready and attached to the dom', this)
			})
		},
	}
</script>
<!-- ******************************************************************* -->
<template>
	<div class="Start">
		<v-container>
			<v-layout row>
				<v-card class="ma-2">
					<v-card-text>
						Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugit
						beatae vel, molestiae omnis, magni id vitae dolorum accusamus
						voluptas harum odio totam fuga eaque cupiditate commodi, inventore
						assumenda quas aliquam.
					</v-card-text>
				</v-card>
			</v-layout>
			<v-layout row>
				<v-flex auto fill-height>
					<v-card class="ma-2">
						<v-card-title>
							Start a new ToDo
						</v-card-title>
						<v-card-text
							>If you are new here, are in a new relationship, or looking to do
							another todo, select this</v-card-text
						>
						<v-card-actions>
							<v-btn flat color="orange">Start a new ToDo</v-btn>
						</v-card-actions>
					</v-card>
				</v-flex>
				<v-flex auto fill-height>
					<v-card class="ma-2">
						<v-card-title>
							Join a ToDo
						</v-card-title>
						<v-card-text>
							If you were sent her by a partner and they gave you a code and a
							secret word, select this.
						</v-card-text>
						<v-card-actions>
							<v-btn color="orange" flat>Join ToDo</v-btn>
						</v-card-actions>
					</v-card>
				</v-flex>
				<!-- <v-flex auto fill-height>
					<v-card class="ma-2">
						<v-card-title>
							Resume a ToDo
							<i class="fa-clipboard-list fal"></i>
								<i class="fa-clipboard-list-check fal"></i>
								<i class="fa-clipboard fal"></i>
								<i class="fa-clipboard-check fal"></i>
								<i class="fa-clipboard-user fal"></i>
								<v-btn color="error" fab large dark>
									<i class="fa-clipboard-user fal"></i>
								</v-btn> 
						</v-card-title>
						<v-card-text>
							It looks like you have an active ToDo. Select this to resume.
						</v-card-text>
						<v-card-actions>
							<v-btn flat color="orange">Resume ToDo</v-btn>
						</v-card-actions>
					</v-card>
				</v-flex> -->
			</v-layout>
		</v-container>
	</div>
</template>
<!-- ******************************************************************* -->
<style scoped>
	.Start {
	}
	.fal {
		font-size: 50px;
		font-weight: 100;
	}
</style>
